module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.18554/js/img/valuePropModals/TeamNoAccess/ValueProp3.svg"